


// import React, { useEffect, useState } from 'react';
// import { MdError } from "react-icons/md";
// import { BiSolidMessageRoundedDots, BiSolidMessageRoundedError } from "react-icons/bi";
// import { contractAbi, contractAddress, tokenAbi, tokenAddress } from '../../contracts';
// import contAbi from '../../contracts/ContractAbi.json'
// import { useReadContract, useWriteContract, useBalance, useChainId, useAccount, useWaitForTransactionReceipt,  } from 'wagmi';

// import { IoMdCheckmarkCircle } from "react-icons/io";
// import axios from 'axios'
// import { useLocation } from 'react-router-dom';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { waitForTransaction, waitForTransactionReceipt } from '@wagmi/core'


// const Registration = () => {
//     const ApiUrl = process.env.REACT_APP_API;

//     const searchParams = new URLSearchParams(window.location.search);
//     const UserReferCode = searchParams.get('userReferralCode')
//     // console.log("Location",searchParams.get('userReferralCode')); // true


//     const [approveState, setApproveState] = useState(false)
//     const { data: hash, isPending, writeContract, writeContractAsync } = useWriteContract()
//     const { address, isConnected, isDisconnected } = useAccount();
//     const [ShowRegister, setShowRegister] = useState(false)
//     const chain = useChainId();
//     const [Run, setRun] = useState(false)
//     const [referrerAddress, setreferrerAddress] = useState('')
//     const [StoreHash, setStoreHash] = useState('')
//     const [RegiHash, setRegiHash] = useState(null)
//     const [CallAPI, setCallAPI] = useState(false)

//     const result = useReadContract({
//         abi: contractAbi,
//         address: contractAddress,
//         functionName: 'BASIC_PRICE',
//     });

//     //Check If The USer Alredy Exits
//     const UserExicts = useReadContract({
//         abi: contractAbi,
//         address: contractAddress,
//         args: [address],
//         functionName: 'isUserExists',
//     });

//     console.log("UserExicts", UserExicts.data)



//     //get Balance
//     const bal = useBalance({
//         address: address,
//         token: tokenAddress,
//     });

//     console.log("isconnect", bal.data, Run)

//     let color = 'red'

//     if (isConnected) {
//         if (bal?.data?.value >= result?.data) {
//             color = 'green'
//         } else {
//             color = 'red'
//         }
//     }

//     //check the Sufficient Funds
//     const balanceSufficient = bal.data?.value >= result.data;
//     // const balanceColor = balanceSufficient ? 'green' : 'red';
//     console.log("balanceSufficient", balanceSufficient)


//     const GetReferrer = async () => {
//         try {
//             const response = await axios.get(`${ApiUrl}/users/referrer/${UserReferCode}`)
//             console.log("response", response)
//             if (response.data) {
//                 setreferrerAddress(response.data.referrerAddress)
//             }
//         } catch (error) {
//             console.log("error of Referrer", error)
//         }
//     }

//     // Approve Function


    
//     const { data, isError, isLoading } = useWaitForTransactionReceipt({
//         hash:hash
//       })

//       console.log("Datattattatatatt",data,Run,StoreHash,RegiHash)

     
      
     
//     const approveFun = async () => {
//         // UserExicts()
//         if (UserReferCode) {


//             if (UserExicts.data === false) {
//                 // if (hash) {
//                 //     setStoreHash(hash)
//                 //     // ShowApprove(true)
//                 //     setRun(true)
//                 // }


//                 if (!Run && balanceSufficient) {
//                     GetReferrer()
//                     try {
//                         const dataget = await writeContractAsync({
//                             abi: tokenAbi,
//                             address: tokenAddress,
//                             functionName: 'approve',
//                             args: [contractAddress, result.data],
//                         });


                        
// //                        if(hash){
// //                             setStoreHash(data.transactionHash)
// //                             setRun(true)
// // console.log("Datattattatatatt enter")
// // // RegisterFun()
// //                        }


//                         // if (data) {
//                         //     setStoreHash(data)
//                         //     // ShowApprove(true)
//                         //     setRun(true)
//                         // }


//                     } catch (error) {
//                         console.log("Error during approval:", error);

//                     }
//                 }

//                 //    else  if(hash){
//                 //         setStoreHash(hash)
//                 //         setRun(true)

//                 //     }
//             }
//             else {
//                 // alert("User Already Exits Result")
//                 toast.error('"User Already Exists');
//             }
//         }
//         else {

//             toast.error('Referal Code is Required');

//         }

//     };


//     // RegisterFun Function 

    


//     const RegisterFun = async () => {

//         // if (hash !== StoreHash) {
//         //     setRegiHash(hash)
//         //     setCallAPI(true)
//         // }
//         // else 

// console.log("enter in rigster fn")

//         if (Run) {
//             try {
//                 const abc = await writeContractAsync({
//                     abi: contAbi,
//                     address: contractAddress,
//                     functionName: "registrationExt",
//                     args: [
//                         referrerAddress,
//                         // "0xc2d1e100334da226781c41B5F4827701ba49e7E5"
//                     ],
//                 });
//                 // console.log("abc", abc)
//                 // if (abc) {
//                 //     setRegiHash(abc)
//                 //     setCallAPI(true)

//                 //     // setTimeout(() => {

//                 //     //     RegisterApi()
//                 //     // }, 3000);

//                 // }

//             } catch (error) {
//                 // alert(error.message || error);
//                 console.log("error", error)

//             }
//         }
//         else {
//             console.log("not run ")
//         }
//         if (RegiHash && CallAPI) {
//             // RegisterApi()
//         }
//     }
//     useEffect(()=>{
//         if(data?.transactionHash){
//             // RegisterFun()
//             setStoreHash(data?.transactionHash)
//             setRun(true)
//           }
    
//       },[data])

//       useEffect(()=>{
// if(Run){
//     RegisterFun()
// }
//       },[StoreHash])


//      useEffect(()=>{
// if(StoreHash){
//     setRegiHash(hash)
// }
//      },[data])
    
//     // User Register API CALL
//     const RegisterApi = async () => {
//         console.log("nooooooooooooooooo")
//         if (CallAPI) {
//             console.log("Enter in RegPAi")
//             const data = {
//                 userAddress: address,
//                 referrer: UserReferCode,
//                 txnHash: RegiHash
//             };
//             try {

//                 const response = await axios.post(
//                     `${ApiUrl}/users/registration`,
//                     data,
//                     {
//                         headers: {
//                             'Content-Type': 'application/json'
//                         }
//                     }
//                 );
//                 console.log("res", response)

//                 if (response) {
//                     setShowRegister(true)
//                     toast.success('User Register SuccessFully');
//                 }
//                 console.log('Registration successful:', response.data);

//             } catch (error) {
//                 console.error('Error during registration:', error);
//                 alert(error.response.data.error)
//             }
//         }
//     };
//     console.log('Approval transaction hash:', StoreHash, Run, isPending);
//     console.log('Register transaction hash:', RegiHash, Run, isPending);

//     // useEffect(() => {
//     //     if (StoreHash !== '') {
//     //         setRun(true);
//     //     }
//     // }, [hash]);

//     // useEffect(() => {
//     //     if (hash) {
//     //         setRun(true)
//     //         setStoreHash(hash)
//     //     }
//     // }, [hash])


//     // useEffect(() => {
//     //     if (StoreHash !== hash && StoreHash) {
//     //         setRegiHash(hash)
//     //         setCallAPI(true)
//     //     }
//     // }, [StoreHash])

import React, { useEffect, useState } from 'react';
import { MdError } from "react-icons/md";
import { BiSolidMessageRoundedDots, BiSolidMessageRoundedError } from "react-icons/bi";
import { contractAbi, contractAddress, tokenAbi, tokenAddress } from '../../contracts';
import contAbi from '../../contracts/ContractAbi.json';
import { useReadContract, useWriteContract, useBalance, useChainId, useAccount, useWaitForTransactionReceipt } from 'wagmi';
import { IoMdCheckmarkCircle } from "react-icons/io";
import axios from 'axios';
import { useLocation, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { connect } from 'react-redux';

const Registration = () => {
    const ApiUrl = process.env.REACT_APP_API;
    // const searchParams = new URLSearchParams(window.location.search);
    // const UserReferCode = searchParams.get('userReferralCode');

    // const getReferralCodeFromUrl = () => {
    //     const hash = window.location.hash;
    //     if (hash.startsWith('#userReferralCode=')) {
    //       return hash.substring('#userReferralCode='.length);
    //     }
    //     return null;
    //   };
    //   const UserReferCode = getReferralCodeFromUrl();
    // const { UserReferCode } = useParams();

    const pathname = window.location.pathname;
    const UserReferCode = pathname.split('=')[1];

    const [approveState, setApproveState] = useState(false);
    const { data: hash, isPending, writeContract, writeContractAsync } = useWriteContract();
    const { address, isConnected } = useAccount();
    const [ShowRegister, setShowRegister] = useState(false);
    const [EnterReferid, setEnterReferid] = useState()
    const chain = useChainId();
    const [Run, setRun] = useState(false);
    const [referrerAddress, setreferrerAddress] = useState('');
    const [StoreHash, setStoreHash] = useState('');
    const [RegiHash, setRegiHash] = useState(null);
    const [CallAPI, setCallAPI] = useState(false);
    console.log("UserReferCodeUserReferCode",UserReferCode || EnterReferid)

    const result = useReadContract({
        abi: contractAbi,
        address: contractAddress,
        functionName: 'BASIC_PRICE',
    });

    const UserExicts = useReadContract({
        abi: contractAbi,
        address: contractAddress,
        args: [address],
        functionName: 'isUserExists',
    });

    const bal = useBalance({
        address: address,
        token: tokenAddress,
    });

    let color = 'red';
    if (isConnected) {
        if (bal?.data?.value >= result?.data) {
            color = 'green';
        } else {
            color = 'red';
        }
    }

    const balanceSufficient = bal.data?.value >= result.data;

    const GetReferrer = async () => {
        try {
            const response = await axios.get(`${ApiUrl}/users/referrer/${UserReferCode  || EnterReferid}`);
            if (response.data) {
                setreferrerAddress(response.data.referrerAddress);
            }
        } catch (error) {
            console.log("error of Referrer", error);
        }
    }

    const { data, isError, isLoading } = useWaitForTransactionReceipt({ hash });

    const approveFun = async () => {
       if(isConnected){
        if (UserReferCode || EnterReferid) {
            if (UserExicts.data === false) {
                console.log("Enter in approve")
                if (!Run && balanceSufficient) {
                    GetReferrer();
                    try {
                        await writeContractAsync({
                            abi: tokenAbi,
                            address: tokenAddress,
                            functionName: 'approve',
                            args: [contractAddress, result.data],
                        });
                    } catch (error) {
                        console.log("Error during approval:", error);
                    }
                }
            } else {
                toast.error('"User Already Exists');
            }
        } else {
            toast.error('Referral  Code is Required');
        }
       }else{
        toast.error('Please Connect Wallet');
       }
    };

    const RegisterFun = async () => {
        console.log("Enter in Register")
        if (Run) {
            try {
                const abc = await writeContractAsync({
                    abi: contAbi,
                    address: contractAddress,
                    functionName: "registrationExt",
                    args: [referrerAddress],
                });
            } catch (error) {
                console.log("error", error);
            }
        }
        // if (RegiHash && CallAPI) {
        //     RegisterApi();
        // }
    }

    
    const RegisterApi = async () => {
        if (CallAPI) {
            const data = {
                userAddress: address,
                referrer: UserReferCode || EnterReferid,
                txnHash: RegiHash,
            };
            try {
                const response = await axios.post(
                    `${ApiUrl}/users/registration`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );
                if (response) {
                    setShowRegister(true);
                    toast.success('User Register SuccessFully');
                }
            } catch (error) {
                console.error('Error during registration:', error);
                alert(error.response.data.error);
            }
        }
    };


    useEffect(() => {
        if (data?.transactionHash) {
            setStoreHash(data?.transactionHash);
            setRun(true);
        }
    }, [data]);

    useEffect(() => {
        if (Run) {
            RegisterFun();
            setCallAPI(true)
        }
    }, [StoreHash]);

    useEffect(() => {
        if (StoreHash) {
            setRegiHash(hash);
        }
    }, [data]);


    useEffect(() => {
        if (CallAPI) {
            RegisterApi();
        }
    }, [RegiHash]);

    


    return (
        <>
            <div className='w-full  min-h-screen py-24 mx-auto bg-gradient-to-r from-[black] to-[#111111]'>
                <section className="text-gray-500 body-font container mx-auto">
                    <div className="container px-5 py-24 mx-auto flex flex-wrap items-center">
                        <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0  ">
                            <h1 className="title-font font-medium text-4xl py-3 mb-5 text-white ">Registration <br /> in Gain Apex  USDT</h1>
                            <div className="relative mb-4 flex flex-col w-full">
                                <label htmlFor="full-name" className="leading-7 py-1 text-sm text-white ">Your upline</label>
                                <input type="text" id="full-name"
                                    // value={1} 
                                    // readOnly
                                    value={UserReferCode}
                                    name="full-name"
                                  placeholder='Referral  ID'
                                    // onChange={(e)=>setEnterReferid(setEnterReferid(e.target.value))}
                                    onChange={(e) => setEnterReferid(e.target.value)}


                                    className=" mt-3 md:w-1/2 lg:w-2/3 w-full rounded-lg  text-base outline-none text-white py-2 px-3 leading-8 transition-colors duration-200 ease-in-out
                                    Box_Backgrounds
                                    " />
                            </div>
                            {isConnected ? (
                                <p className='flex gap-5 items-center py-2 text-green-600 text-xl font-medium '><span><IoMdCheckmarkCircle size={25} /></span> Wallet: connected</p>
                            ) : (
                                <p className='flex gap-5 items-center py-2 
                                text-red-600 text-xl font-medium '><span><MdError size={25} /></span> Wallet: Not Connected</p>
                            )}
                            <div className='md:block hidden lg:block'>
                                {chain === chain && isConnected ? (
                                    <p className='flex items-center text-green-600 py-2 font-medium text-xl gap-5'><span ><IoMdCheckmarkCircle size={25} /></span> Network</p>
                                ) :
                                    // <p className='flex items-center text-red-600 py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Network</p>
                                    <p className='flex gap-5 items-center py-2 text-red-600 text-xl font-medium '><span><MdError size={25} /></span>Network Not Connected</p>

                                }
                                {/* <p style={{ color: balanceColor }} className='flex items-center text-green-600 py-2 font-medium text-xl gap-5'> {color === "green" ? <span><IoMdCheckmarkCircle size={25} /></span> : <span className=' rounded-full p-2 border-[2px] border-red-600 '></span>} Balance</p> */}


                                {/* <p style={{ color: balanceColor }} className='flex items-center text-green-600 py-2 font-medium text-xl gap-5'>
                                    {balanceColor === "green" ? <IoMdCheckmarkCircle size={25} /> : <span className='rounded-full p-2 border-[2px] border-red-600'></span>} Balance
                                </p> */}

                                {balanceSufficient ? (
                                    <p className='flex items-center py-2 font-medium text-green-600 text-xl gap-5'><span><IoMdCheckmarkCircle size={25} /></span> Balance</p>
                                ) : (
                                    // <p className='flex items-center text-red-600 py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span>insufficient Balance</p>
                                    <p className='flex gap-5 items-center py-2 text-red-600 text-xl font-medium '><span><MdError size={25} /></span>insufficient Balance</p>
                                )

                                }


                                {Run && balanceSufficient ? (
                                    <p className='flex items-center py-2 font-medium text-green-600 text-xl gap-5'><span><IoMdCheckmarkCircle size={25} /></span> Approve BUSD</p>
                                ) : (
                                    // <p className='flex items-center text-red-600 py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Approve BUSD</p>
                                    <p className='flex gap-5 items-center py-2 text-red-600 text-xl font-medium '><span><MdError size={25} /></span> Approve BUSD</p>
                                )

                                }

                                
                                {
                                    // approveState === null
                                    ShowRegister && balanceSufficient
                                        ? (<p className='flex items-center py-2 text-green-600 font-medium text-xl gap-5'><span><IoMdCheckmarkCircle size={25} /></span> Registration</p>
                                        ) :
                                        (
                                            // <p className='flex items-center py-2 text-red-600 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-red-600 '></span> Registration</p>
                                            <p className='flex gap-5 items-center py-2 text-red-600 text-xl font-medium '><span><MdError size={25} /></span>Registration</p>
                                        )}

                            </div>




                            <button
                                onClick={!Run ? approveFun : RegisterFun}
                                className=' hidden md:block lg:block w-1/4 font-bold mt-5 hover:bg-blue-500 rounded-lg py-5 px-4 bg-[#c234ac] text-white '>
                                Registration
                            </button>


                            <p className='md:flex lg:flex hidden gap-3 items-center ml-6 py-2  font-medium '>Registration fee<span><BiSolidMessageRoundedError size={20} /></span> </p>
                        </div>
                        <div className="lg:w-2/5 md:w-2/2 bg-gray-100 rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0">
                            <p className='flex gap-5 items-center text-2xl font-medium  text-[#c234ac]'><span><MdError size={25} /></span> Information</p>
                            <p className='text-xl font-medium pt-4 pb-3'>Wallet not connected.</p>
                            <p className='text-gray-600 Access_website'>Access the website via cryptowallet dapp browser (”Discover” button in Tokenpoket) or with Metamask extension installed.</p>
                            <button className=' md:w-full lg:w-full w-full font-bold mt-5  md:rounded-[20px] lg:rounded-[20px] rounded-lg py-2 px-3 bg-[#c234ac] text-white'>Read guide</button>
                            <iframe className='hidden md:block lg:block mt-5 w-full h-[200px]' src="https://www.youtube.com/embed/0wL2kpuctmk?si=5fCKBRbZMck0aq_g" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                            <p className='md:flex hidden lg:flex items-center gap-4 mt-8'><span><BiSolidMessageRoundedDots size={25} /></span>Need help with registration? Talk to experts in the support chat</p>
                        </div>
                        <div className=' block md:hidden lg:hidden mt-5'>
                            <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Network</p>
                            <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Registration</p>
                            <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Balance</p>
                            <p className='flex items-center py-2 font-medium text-xl gap-5'><span className=' rounded-full p-2 border-[2px] border-gray-600 '></span> Approve BUSD</p>
                        </div>
                    </div>
                </section>
            </div>

            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                // pauseOnHover
                theme="light"
            />
        </>
    );
};

export default Registration;
